define('views/modules/questionnaire/send-questionnaire-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'services/i18n',
    //models
    'models/questionnaire/questionnaire',
    // views
    'views/modules/conversation/message/send-message-modal'
], function(
    // Libs
    _, Backbone, Mustache, U, i18n,
    // models
    MQuestionnaire,
    // views
    VSendMessageModal
) {
    var VSendQuestionnaireModal = VSendMessageModal.extend({
        modal: function() {
            return { title: i18n.t("Publish questionnaire") };
        },

        initialize: function(opt) {
            _.extend(opt, { attachment: false });
            VSendQuestionnaireModal.__super__.initialize.call(this, opt);
            this.questionnaire = new MQuestionnaire();
        },

        buttons: function(buttons) {
            return _.extend(buttons, {
                confirm: {
                    label: i18n.t("questionnaire:Send"),
                    callback: this.onConfirm
                },
            });
        },

        render: function() {
            VSendQuestionnaireModal.__super__.render.apply(this, arguments);
            this.view.chatbox.setValue(Mustache.render('{{{guidelines}}}\n\n<br/>{{{questionnaireUrl}}}', {
                guidelines: i18n.t('messages:message-publish-questionnaire'),
                questionnaireUrl: this.questionnaire.getAbsoluteUrl()
            }));
        },

        setQuestionnaire: function(model) {
            if (!model) return;
            var attrs = model.attributes || model;
            this.questionnaire.reset(attrs);
            return this;
        },

        getMessageAttributes: function() {
            var attributes = VSendQuestionnaireModal.__super__.getMessageAttributes.apply(this, arguments);
            return _.extend(attributes, { type: 'questionnaire' });
        },

        ////////////
        // events //
        ////////////

    });

    return VSendQuestionnaireModal;
});

